const KEY_SERACH_HISTORY = 'search_history';

export const getHistory = () => {
  let str = window.localStorage.getItem(KEY_SERACH_HISTORY);
  return str ? JSON.parse(str) : [];
}

export const setHistory = (history) => {
  window.localStorage.setItem(KEY_SERACH_HISTORY, JSON.stringify(history));
}
